import * as firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'
import 'firebase/auth'
import 'firebase/functions'
import 'firebase/firebase-analytics'
import { firebaseConfig } from '@/config/firebaseConfig'

const app = firebase.apps.length
  ? firebase.app()
  : firebase.initializeApp(firebaseConfig)

export const firestore = app.firestore()
export const storage = app.storage()
export const auth = app.auth()
export const authObject = firebase.auth
export const functions = app.functions('asia-northeast1')
export const analytics = app.analytics()
export default firebase